import { Button } from '@/components/ui/button'
import { Dispatch, ReactNode, SetStateAction } from 'react'
import { ChevronDownIcon } from '@radix-ui/react-icons'

interface HideShowSelectorSectionPropsType {
  noHideButton?: boolean
  showOptions: boolean
  setShowOptions: Dispatch<SetStateAction<boolean>>
  heading: ReactNode
  content: ReactNode
}

export default function HideShowSelectorSection({
  noHideButton,
  showOptions,
  setShowOptions,
  heading,
  content,
}: HideShowSelectorSectionPropsType) {
  return (
    <div className={'bg-secondary border-muted rounded-2xl p-6'}>
      <div className={'flex items-center justify-between'}>
        {heading ?? <div />}
        {noHideButton || (
          <Button onClick={() => setShowOptions((prev) => !prev)} variant={'ghost'}>
            {showOptions ? 'Hide' : 'More'}
            {!showOptions && <ChevronDownIcon />}
          </Button>
        )}
      </div>
      {showOptions && content}
    </div>
  )
}
